import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  bundleContent: {
    display: "flex",
    gap: theme.spacing.space12,
    padding: theme.spacing.space12,
    alignItems: "center",
    background: theme.colors.background3,
    borderRadius: theme.radius.small,
    color: theme.colors.text1,
  },
  bundleInfo: {
    display: "flex",
    gap: theme.spacing.space12,
    width: "100%",
    overflow: "hidden",
  },
  icon: {
    padding: theme.spacing.space8,
    borderRadius: theme.radius.small,
    border: `1px solid ${theme.colors.border1}`,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "start",
  },
  bundleName: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
}));
